<template>
    <div>
        <v-row dense>
            <v-col cols="6" class="text-center">
                <label>{{ $t('adults') }}</label>
                <v-text-field
                    ref="adults"
                    :key="adultsKey"
                    :model-value="adultsCount"
                    append-icon="mdi-plus"
                    prepend-icon="mdi-minus"
                    data-cy="adults-selector"
                    :disabled="disabled"
                    class="pt-0"
                    density="compact"
                    variant="outlined"
                    @click:append="inputAdults(adultsCount + 1)"
                    @click:prepend="inputAdults(adultsCount - 1)"
                    @update:model-value="inputAdults"
                />
            </v-col>
            <v-col cols="6" class="text-center">
                <label>{{ $t('children') }}</label>
                <v-text-field
                    ref="children"
                    :key="childrenKey"
                    :model-value="childrenAges.length"
                    append-icon="mdi-plus"
                    prepend-icon="mdi-minus"
                    data-cy="children-selector"
                    :disabled="disabled"
                    class="pt-0"
                    density="compact"
                    variant="outlined"
                    @click:append="inputChildren(childrenAges.length + 1)"
                    @click:prepend="inputChildren(childrenAges.length - 1)"
                    @update:model-value="inputChildren"
                />
            </v-col>
        </v-row>
        <v-row dense>
            <v-col v-show="childrenAges.length > 0" :cols="12">
                <label>
                    {{ $t('children_ages') }}
                </label>
            </v-col>
            <v-col v-for="(age, index) in childrenAges" :key="index" cols="4">
                <v-select
                    :key="index"
                    :model-value="age"
                    :items="childrenAgeItems"
                    variant="outlined"
                    density="compact"
                    data-cy="children-age-selector"
                    class="pt-0"
                    @update:model-value="changeAge($event, index)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    const restrictNumber = (v, min, max) => {
        const maxLength = String(max).length
        let value = !v ? min : parseInt(v.length > maxLength ? v.slice(-1) : v, 10)
        if (value === 0 || (String(value).length === maxLength && value < min)) value = min
        else if (value > max) value = max
        return value
    }

    @Component
    export class TouristsSelect extends Vue {
        @Prop({default: 5}) maxAdults
        @Prop({default: 5}) maxChildren
        @Prop() maxTotal
        @Prop() _adults
        @Prop() _childrenAges

        //TODO Need refactoring - create snippets/NumberField
        adultsKey = 0
        childrenKey = 0

        @Emit()
        changeAdults(val) {
            return val
        }

        @Emit()
        changeChildrenAges(val) {
            return val
        }

        @Emit()
        changeAge(age, index) {
            this.childrenAges[index] = age
        }

        async inputChildren(childrenCount) {
            childrenCount = restrictNumber(childrenCount, 0, this.maxChildrenTotal)
            const childrenAgesLength = this.childrenAges.length
            if (childrenAgesLength === childrenCount) {
                this.childrenKey++
                await this.$nextTick
                this.$refs.children.focus()
            }
            if (childrenAgesLength < childrenCount) {
                for (let i = 0; i < childrenCount - childrenAgesLength; i++) {
                    this.childrenAges.push(2)
                }
            } else {
                this.childrenAges = this.childrenAges.slice(0, childrenCount)
            }
        }

        async inputAdults(v) {
            const value = restrictNumber(v, 1, this.maxAdultsTotal)
            if (this.adults === value) {
                this.adultsKey++
                await this.$nextTick
                this.$refs.adults.focus()
            }
            this.adults = value
        }

        get childrenAgeItems() {
            return Array.from(Array(18).keys())
        }

        get adultsCount() {
            return authStore.user.isEmployeeOrExternalCorp ? 1 : this.adults
        }

        get disabled() {
            return authStore.user.isEmployeeOrExternalCorp
        }

        get maxAdultsTotal() {
            return this.maxTotal ? this.maxTotal - this.childrenAges.length : this.maxAdults
        }

        get maxChildrenTotal() {
            return this.maxTotal ? this.maxTotal - this.adults : this.maxChildren
        }

        get adults() {
            return this._adults
        }

        set adults(val) {
            this.changeAdults(val)
        }

        get childrenAges() {
            return this._childrenAges
        }

        set childrenAges(val) {
            this.changeChildrenAges(val)
        }
    }

    export default TouristsSelect
</script>

<style scoped>
    label {
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
    }
</style>
